module.exports = __webpack_public_path__ + "img/face-surprise.528bfc9d.svg";